// BUILD-046 Owner correction 2 (2026-10-24): the pure parts of the requester's view of the work done on a task they issued - the Phoenix-clock wording of a recorded time, and whether a summary has anything to
// say. Kept apart from the React file (RequesterInsightView.tsx) so they can be tested directly. Erasable TypeScript only; type-only imports plus the pure due-date formatter.
import type { IssuedProgress } from './issuedRequestsModel';
import { formatDueDate } from './taskRowModel';

/** "Oct 22, 3:41 PM" on the Phoenix clock; '' when the instant cannot be read. The recorded time is its own value: it is never the activity date. */
export function recordedAtText(iso: string): string {
  const ms = Date.parse(iso);
  if (!Number.isFinite(ms)) return '';
  return new Intl.DateTimeFormat('en-US', { timeZone: 'America/Phoenix', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }).format(new Date(ms));
}

/** True when there is anything for the labelled summary to say: a latest progress note, a next action or a readable follow-up date. */
export function hasInsightLines(progress: IssuedProgress | null, nextAction: string, followUpDate: string): boolean {
  return progress !== null || nextAction.trim() !== '' || formatDueDate(followUpDate) !== null;
}
